import React, { useState, useEffect } from "react";
import "./WalletDetails.scss";
import ShopItem from "components/shops/shopItem";
import edit from "../../assets/images/Icon awesome-edit.png";
import back from "../../assets/images/icons8-arrow-left-66.png";
import { connection } from "utils/apiConnection.ts";
import Swal from "sweetalert2";

const WalletDetails = ({ wallet, setWallet, user, coin, setLoader }) => {
  const [editUser, setEditUser] = useState(false);
  const [walletE, setWalletE] = useState(
    wallet.map((value) => {
      return { ...value };
    })
  );
  const onClickHandlerEdit = () => {
    setEditUser(!editUser);
  };
  const onClickHandlerSubmit = async () => {
    setLoader(true);
    let data = {
      userId: user.id,
    };
    walletE.forEach((value) => {
      data[`${value.shopId},1`] = value.recieveEmail;
      data[`${value.shopId},2`] = value.recieveSMS;
      data[`${value.shopId},3`] = value.shareProfile;
    });
    let result = await connection("savesettings", data);
    if (result.status == 1) {
      setEditUser(!editUser);
      setWallet(
        walletE.map((value) => {
          return { ...value };
        })
      );
      theAlert(1);
    } else {
      theAlert(2);
      onClickHandlerBack();
    }
    setLoader(false);
  };
  const onClickHandlerBack = () => {
    if (editUser === true) {
      setEditUser(!editUser);
      setWallet(
        walletE.map((value) => {
          return { ...value };
        })
      );
    }
  };
  function theAlert(type) {
    let my_icon = type === 1 ? "success" : "error";
    Swal.fire({
      icon: my_icon,
      title: `${type === 1 ? "تایید" : "خطا"} `,
      text: `${
        type === 1
          ? "اطلاعات شما با موفقیت ثبت شد"
          : "مشکلی در ثبت اطلاعات به وجود آمده است"
      }`,
    });
  }
  useEffect(() => {
    setWalletE(
      wallet.map((value) => {
        return { ...value };
      })
    );
  }, [wallet]);
  return (
    <div className="wallet">
      <div style={{ textAlign: "-webkit-center", marginTop: "40px" }}>
        <div className="circle1">
          <div className="triangle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="117.734"
              height="144.88"
              viewBox="0 0 117.734 144.88"
            >
              <path
                id="Path_369"
                data-name="Path 369"
                d="M57.629,142.891,115.258,17.327,108.1,12.451,97.687,8.233S72.851,0,59.578,0C30.763,0,0,17.327,0,17.327Z"
                transform="matrix(-1, -0.017, 0.017, -1, 115.24, 144.88)"
                fill="#fe7669"
              />
            </svg>
            <div className="circle2">
              <div className="rate">{coin} امتیاز</div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ margin: "40px 0px", fontSize: "20px", color: "#1C2140" }}>
        اطلاعات ولت
      </div>
      {walletE.length > 0 ? (
        <>
          <div className="btn edit col-12">
            {editUser ? (
              <>
                <img src={edit} alt="edit" width={15} height={15} />
                <span onClick={onClickHandlerSubmit}>
                  {" "}
                  ثبت تنظیمات فروشگاه ها
                </span>
              </>
            ) : (
              <>
                <img src={edit} alt="edit" width={15} height={15} />
                <span onClick={onClickHandlerEdit}>
                  {" "}
                  ویرایش تنظیمات فروشگاه ها
                </span>
              </>
            )}
          </div>
          {editUser ? (
            <div className="btn back col-12" onClick={onClickHandlerBack}>
              <img src={back} alt="back" width={20} height={20} />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {walletE.map((value, index) => {
        const demoBusiness = {
          coverImg: value.coverImg,
          logoImg: value.logoImg,
          title: value.title,
        };
        return (
          <div className="row" key={index}>
            <div className="col-12 col-sm-7 col-md-3 col-xxl-2">
              <ShopItem item={demoBusiness} />
            </div>
            <div className="card col-12 col-sm-9" key={index}>
              <div className="items col-12 col-lg-4 ">
                <div className="col-6">دریافت ایمیل</div>
                <div
                  className="button b2"
                  id="button-13"
                  onClick={(e) =>
                    setWalletE((wallet) => {
                      return wallet.map((val, ind) => {
                        if (ind === index)
                          return {
                            ...val,
                            recieveEmail: val.recieveEmail == 1 ? 0 : 1,
                          };
                        return val;
                      });
                    })
                  }
                >
                  <input
                    disabled={editUser ? "" : "disabled"}
                    type="checkbox"
                    className="checkbox"
                    value={`${value.shopId},1`}
                    checked={value.recieveEmail === 1 ? true : false}
                  />
                  <div
                    className={`knobs ${
                      value.recieveEmail === 1 ? "active" : "inactive"
                    }`}
                  >
                    <span></span>
                  </div>
                  <div className="layer"></div>
                </div>
              </div>
              <div className="items col-12 col-lg-4 ">
                <div className="col-6">دریافت پیامک</div>
                <div
                  className="button b2"
                  id="button-13"
                  onClick={(e) =>
                    setWalletE((wallet) => {
                      return wallet.map((val, ind) => {
                        if (ind === index)
                          return {
                            ...val,
                            recieveSMS: val.recieveSMS == 1 ? 0 : 1,
                          };
                        return val;
                      });
                    })
                  }
                >
                  <input
                    disabled={editUser ? "" : "disabled"}
                    type="checkbox"
                    className="checkbox"
                    value={`${value.shopId},2`}
                    checked={value.recieveSMS === 1 ? true : false}
                  />
                  <div
                    className={`knobs ${
                      value.recieveSMS === 1 ? "active" : "inactive"
                    }`}
                  >
                    <span></span>
                  </div>
                  <div className="layer"></div>
                </div>
              </div>
              <div className="items col-12 col-lg-4 ">
                <div className="col-6">اشتراک اطلاعات فردی</div>
                <div
                  className="button b2"
                  id="button-13"
                  onClick={(e) =>
                    setWalletE((wallet) => {
                      return wallet.map((val, ind) => {
                        if (ind === index)
                          return {
                            ...val,
                            shareProfile: val.shareProfile == 1 ? 0 : 1,
                          };
                        return val;
                      });
                    })
                  }
                >
                  <input
                    disabled={editUser ? "" : "disabled"}
                    type="checkbox"
                    className="checkbox"
                    value={`${value.shopId},3`}
                    checked={value.shareProfile === 1 ? true : false}
                  />
                  <div
                    className={`knobs ${
                      value.shareProfile === 1 ? "active" : "inactive"
                    }`}
                  >
                    <span></span>
                  </div>
                  <div className="layer"></div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WalletDetails;
